import { render, staticRenderFns } from "./AddArticleDialog.vue?vue&type=template&id=558e5fa5"
import script from "./AddArticleDialog.vue?vue&type=script&lang=ts"
export * from "./AddArticleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports